<template>
  <div>
    <div
        v-for="(answer, index) in questionModel.language[this.$parent.quizData.language].answers"
        :key="index"
        class="question"
        :class="{
        valid: questionModel.answered && questionModel.answerIds.includes(index),
        unvalid: questionModel.answered && $parent.quizData.selectedAnswerId === index && !questionModel.answerIds.includes(index)
      }"
        @click="selectAnswer($event, index)"
    >
      <div class="question-answer">{{ answer }}</div>
    </div>

    <!-- Conteneur conditionnel basé sur la propriété iframe -->
    <div v-if="!this.$parent.quizData.iframe">
      <button
          v-if="questionModel.id == this.$parent.quizData.questions.length - 1 && !this.$parent.quizData.endPage"
          class="question-answered-button question-answered-button-final"
          @click="endQuiz"
      >
        <img :src="this.$parent.getPic(this.questionModel.language[this.$parent.quizData.language].endButton)" width="30%">
      </button>

      <button
          v-else
          class="question-answered-button question-answered-button-next"
          @click="nextQuestion"
      >
        <img :src="this.$parent.getPic(this.questionModel.language[this.$parent.quizData.language].nextButton)" width="30%">
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Question',
  props: ['questionModel'],
  methods: {
    selectAnswer(event, index) {
      this.$emit('select-answer', event, index);
      this.questionModel.answered = true;
      window.parent.postMessage({
        type: 'question-answered',
        questionId: this.questionModel.id + 1,
        totalQuestions: this.$parent.quizData.questions.length,
        answered : true
      }, '*');
    },
    nextQuestion() {
      this.$emit('change-question', null, this.questionModel.id + 1);
      window.parent.postMessage({
        type: 'change-question',
        questionId: this.questionModel.id + 1,
        totalQuestions: this.$parent.quizData.questions.length
      }, '*');
    },
    endQuiz() {
      this.$parent.quizData.endPage = true;
      // Envoie un message à la page parente pour indiquer que le quiz est terminé
    }
  },
  created() {
    window.parent.postMessage({
      type: 'total-questions',
      totalQuestions: this.$parent.quizData.questions.length
    }, '*');
    window.addEventListener('message', (event) => {
      if (event.data === 'next') {
        this.nextQuestion();
      } else if (event.data === 'prev') {
        this.$emit('change-question', null, this.questionModel.id - 1);
        window.parent.postMessage({
          type: 'change-question',
          questionId: this.questionModel.id - 1,
          totalQuestions: this.$parent.quizData.questions.length
        }, '*');
      } else if (event.data === 'end-quiz') {
        this.endQuiz(); // Appelle endQuiz lorsque le message 'end-quiz' est reçu
      }
    });
  }
}
</script>
